export default __webpack_public_path__ + "static/media/TG.c3ad2bfd.svg";